var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountOverviewMyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8242 13.125C17.0039 13.125 19.625 15.7461 19.625 18.9258V20.6875C19.625 21.8477 18.6797 22.75 17.5625 22.75H2.4375C1.27734 22.75 0.375 21.8477 0.375 20.6875V18.9258C0.375 15.7461 2.95312 13.125 6.13281 13.125C7.37891 13.125 7.9375 13.8125 10 13.8125C12.0195 13.8125 12.5781 13.125 13.8242 13.125ZM18.25 20.6875V18.9258C18.25 16.4766 16.2734 14.5 13.8242 14.5C13.0078 14.5 12.1484 15.1875 10 15.1875C7.80859 15.1875 6.99219 14.5 6.13281 14.5C3.68359 14.5 1.75 16.4766 1.75 18.9258V20.6875C1.75 21.0742 2.05078 21.375 2.4375 21.375H17.5625C17.9062 21.375 18.25 21.0742 18.25 20.6875ZM10 11.75C6.94922 11.75 4.5 9.30078 4.5 6.25C4.5 3.24219 6.94922 0.75 10 0.75C13.0078 0.75 15.5 3.24219 15.5 6.25C15.5 9.30078 13.0078 11.75 10 11.75ZM10 2.125C7.72266 2.125 5.875 4.01562 5.875 6.25C5.875 8.52734 7.72266 10.375 10 10.375C12.2344 10.375 14.125 8.52734 14.125 6.25C14.125 4.01562 12.2344 2.125 10 2.125Z",
    fill: "#CE0E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountOverviewMyProfile);
export default __webpack_public_path__ + "static/media/AccountOverviewMyProfile.aa7f326ae11902c6a44a8c10d27ecf79.svg";
export { ForwardRef as ReactComponent };